import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useForm, Controller } from 'react-hook-form';
import * as actions from '../../redux/actions';
import { ViewTitle } from 'components/ViewTitle';
import RegisterForm from '../../components/Forms/RegisterForm';

export default function Register({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const confirm = window.confirm('ยืนยันการสมัครสมาชิก?');
    if (confirm) {
      dispatch(actions.userRegister(data));
    }
  };

  const renderForm = () => (
    <form onSubmit={handleSubmit(onSubmit)}>
      <RegisterForm control={control} Controller={Controller} errors={errors} />
    </form>
  );

  return <div className="p-4 md:p-10 mx-auto w-full">{renderForm()}</div>;
}
